// libs
import { css } from '@emotion/core';

// constants
import { MARGIN_RIGHT } from 'shared/components/AdPlatformWidgets/Desktop/constant';

export const getColumnDimension = (numOfColumns: number) => css`
  width: calc((100% - ${(numOfColumns - 1) * MARGIN_RIGHT}px) / ${numOfColumns});

  // nth-of-type breaks when all the elements aren't of the same type
  // TODO: identify why global class identifiers were not working
  &:nth-child(${numOfColumns}n) {
    margin-right: 0;
  }
`;
